'use strict';

(function () {
  angular.module('specsguardApp')
    .factory('BuildingTemplateAPI', BuildingTemplateApi);

  BuildingTemplateApi.$inject = ['$resource'];

  function BuildingTemplateApi ($resource) {
    return $resource('/api/buildingtemplate/:id', {
      id: '@id'
    }, {
      update: {
        method: 'PATCH'
      },
      copy: {
        method: 'POST'
      }
    });
  }
})();
